import React from 'react';

function IconError({
  width = '1rem',
  style,
  viewBox = '0 0 24 24',
  className,
  fill = 'currentColor',
}) {
  return (
    <svg
      width={width}
      style={style}
      height={width}
      viewBox={viewBox}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.001 2a2.99 2.99 0 0 1 2.47 1.302h.003l.005.01c.018.024.03.052.047.077l6.953 11.922c.019.026.031.056.049.083l.128.219c.211.422.345.887.344 1.387a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3c0-.659.219-1.264.58-1.759L9.39 3.533l.01-.001A2.987 2.987 0 0 1 12.001 2zM12 4a.987.987 0 0 0-.861.517 1.59 1.59 0 0 1-.104.166L4.308 16.247a1.56 1.56 0 0 1-.111.171.976.976 0 0 0-.196.582c0 .551.449 1 1 1h14A1 1 0 0 0 20 17a.963.963 0 0 0-.124-.454 1.782 1.782 0 0 1-.037-.076l-.04-.069a.509.509 0 0 0-.03-.05.558.558 0 0 0-.019-.033L12.801 4.404A.99.99 0 0 0 12 4zm0 11a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0-8c.552 0 1 .522 1 1.167v4.666c0 .645-.448 1.167-1 1.167s-1-.522-1-1.167V8.167C11 7.522 11.448 7 12 7z"
        fill={fill}
        fillRule="nonzero"
      />
    </svg>
  );
}
export default IconError;
